interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "primary" | "accent" | "secondary";
}

const toneMap = {
  primary: "text-primary-600",
  accent: "text-accent-600",
  secondary: "text-secondary-600",
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "primary",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${centered ? "items-center text-center" : "items-start"}`}>
      <span className={`inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide ${toneMap[tone]}`}>
        <span className="w-6 h-px bg-current" aria-hidden="true"></span>
        {eyebrow}
      </span>
      <h2 className="font-heading text-foreground-950 text-3xl md:text-4xl leading-tight">{title}</h2>
      {desc && (
        <p className={`text-foreground-600 text-sm md:text-base leading-relaxed ${centered ? "max-w-2xl" : "max-w-3xl"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}